import { Transcoder } from '@img-arena/consoles-api-streaming'

import { ActionDeleteItem } from '../ActionDeleteItem/ActionDeleteItem'

interface ActionDeleteTranscoderItemProps {
  onDelete: (row: Transcoder) => Promise<void> | void
}

export const ActionDeleteTranscoderItem = ({ onDelete }: ActionDeleteTranscoderItemProps) => (
  <ActionDeleteItem
    onDelete={onDelete}
    successMessage={(row) => `Transcoder ${row.id} (${row.ip}) deleted successfully`}
    errorMessage={(row) => `Failed to delete Transcoder ${row.id} (${row.ip})`}
    confirmationMessage={(row) =>
      `Are you sure you want to delete Transcoder ${row.id} (${row.ip})?`
    }
  />
)
